import React from 'react'
import { Row } from 'reactstrap'
type IProps ={
  subTitle: string ;
  className?: string ;
}
const TableSubHeader = ({
  subTitle,
  className
}:IProps) => {
  return (
    <Row className={`justify-content-center pt-1 mx-2 mt-4 ] ${className && className}`} style={{backgroundColor:"#E4E4E4"}}>
       <h2>{subTitle}</h2>
    </Row>
  )
}

export default TableSubHeader
